import {createSvgIcon} from '../create-svg-icon';

export const TransitEnterexitIcon = createSvgIcon(
  <path d="M16 18H6V8h3v4.77L15.98 6 18 8.03 11.15 15H16v3z" />
, 'TransitEnterexitOutlined');
